import React, { useMemo, useState } from "react";
import useGuidesList from "../hooks/useGuidesList";
import Container from "../components/Container";
import GuideDownload from "../components/GuideDownload";
//import DownloadsBadge from "../components/DownloadsBadge";


const isValidDate = (d) => {
  if (!d) return false;
  const dt = new Date(d);
  return !isNaN(dt) && dt.getFullYear() > 2000;
};



export default function Guides() {
 const all = useGuidesList(); // now coming from Google Sheet via API
 const guides = all.filter(g => g.category === "Guides");
  // helpers
  const clean = (s) => (s || "").toLowerCase().trim();
  const isGuide = (a) => {
  const c = clean(a.category);
  return c === "guides" || c === "guide" || c === "investment guides" || c.includes("guide");
};
  // parse CSV tags from sheet
  const getTags = (a) =>
    (a.tags || a.Tags || "")
      .split(",")
      .map((t) => clean(t))
      .filter(Boolean);

  // only guides feed this page
 // const guides = useMemo(() => {
 // const filtered = all.filter(isGuide);
 // return filtered.length ? filtered : all;
// }, [all]);

  // static, capitalised filter list (AND logic)
  const TAG_OPTIONS = [
    "Beginners",
    "Due Diligence",
    "Off-Plan",
    "Yield",
    "Financing",
    "Remortgage",
    "Landlord Law",
    "Tax",
    "Mortgages",
    "Forecasts",
    "Market Insights",
    "2025",
  ];

  const [selectedTags, setSelectedTags] = useState([]); // store lowercase slugs
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("Newest");

  const toggleTag = (label) => {
    const slug = label.toLowerCase();
    setSelectedTags((prev) =>
      prev.includes(slug) ? prev.filter((t) => t !== slug) : [...prev, slug]
    );
  };

  const filtered = useMemo(() => {
    const q = clean(query);
    let arr = guides.filter((a) => {
      const tags = getTags(a); // already lowercased
      const tagMatch =
        selectedTags.length === 0 ||
        selectedTags.every((t) => tags.includes(t)); // AND logic
      const qMatch =
        !q || clean(a.title).includes(q) || clean(a.excerpt).includes(q);
      return tagMatch && qMatch;
    });

    return arr.sort((a, b) =>
      sort === "Newest"
        ? new Date(b.date) - new Date(a.date)
        : new Date(a.date) - new Date(b.date)
    );
  }, [guides, query, selectedTags, sort]);

  return (
    <main>
      {/* Hero */}
      <section className="relative overflow-hidden">
        <img
          src="/content/images/guide-hero.jpg"
          alt="Guides header"
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-white/30 to-white" />
        <Container className="relative py-16 sm:py-20">
          <h1 className="text-4xl font-bold text-[#003366]">Investment Guides</h1>
          <p className="mt-3 text-[#003366] max-w-2xl">
            Downloadable e‑guides and practical frameworks to help you evaluate
            deals, structure finance and manage risk.
          </p>
        </Container>
      </section>

      {/* Controls */}
<section>
  <Container className="py-6 space-y-4">
    <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search guides…"
        className="w-full sm:w-80 rounded-xl border border-slate-300 px-3 py-2"
      />
      <select
        value={sort}
        onChange={(e) => setSort(e.target.value)}
        className="rounded-xl border border-slate-300 px-3 py-2"
      >
        <option>Newest</option>
        <option>Oldest</option>
      </select>
    </div>

    {/* Static, capitalised topic chips (currently disabled)
    <div>
      <div className="text-sm font-semibold text-[#003366] mb-2">
        Filter by topic
      </div>
      <div className="flex flex-wrap gap-2">
        {TAG_OPTIONS.map((label) => {
          const slug = label.toLowerCase();
          const active = selectedTags.includes(slug);
          return (
            <button
              key={slug}
              onClick={() => toggleTag(label)}
              className={`rounded-full border px-3 py-1 text-sm font-medium capitalize ${
                active
                  ? "bg-slate-900 text-white border-slate-900"
                  : "border-slate-300 text-[#003366] hover:bg-slate-50"
              }`}
            >
              {label}
            </button>
          );
        })}
        {selectedTags.length > 0 && (
          <button
            onClick={() => setSelectedTags([])}
            className="ml-2 rounded-full border border-slate-300 px-3 py-1 text-sm text-[#003366] hover:bg-slate-50"
          >
            Clear
          </button>
        )}
      </div>
    </div>
    */}
  </Container>
</section>

      {/* Results */}
      <section>
        <Container className="pb-16">
          {filtered.length === 0 ? (
            <div className="rounded-xl border border-dashed border-slate-300 p-6 text-[#003366]">
              No matching guides yet.
            </div>
          ) : (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {filtered.map((a) => (
                <article
                  key={a.id}
                  className="rounded-3xl bg-white shadow-sm ring-1 ring-slate-200 overflow-hidden"
                >
                  <div className="relative">
        
                  <img
                    src={a.image}
                    alt=""
                    className="h-48 w-full object-cover"
                  />
                  </div>
                  <div className="p-6">
                    <div className="text-xs font-semibold uppercase tracking-wide text-[#003366]">
                      {a.category}
                    </div>
                    <h3 className="mt-1 text-lg font-semibold text-[#003366]">
                      {a.title}
                    </h3>
                    <p className="mt-2 text-[#003366]">{a.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between gap-3 text-sm text-[#003366]">
  
    

  <div className="flex items-center gap-3">
   <a
  href={
    (a.category || "").toLowerCase() === "guides"
      ? `#/guide/${a.slug}`
      : `#/article/${a.slug}`
  }
  className="font-semibold text-[#003366]"
>
  Read more →
</a>

    {/* Inline, modal-triggering download button */}
    <GuideDownload guideId={a.id || a.slug || a.guid}
               guideTitle={a.title || a.name || a.heading || a.slug}
slug={a.slug} />



  </div>
</div>


                    {/* Show tags for context */}
                    {getTags(a).length > 0 && (
                      <div className="mt-3 flex flex-wrap gap-1">
                        {getTags(a).map((t) => (
                          <span
                            key={t}
                            className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-[#003366]"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </article>
              ))}
            </div>
          )}
        </Container>
      </section>
    </main>
  );
}
